export default __webpack_public_path__ + "bfa11daf77e5358e323dfebccb3cf52a.png";